export default __webpack_public_path__ + "static/media/feedback-image.f670948f.svg";